import React from "react";

const STATUS_CLASS: Record<string, string> = {
  PLANIFIEE: "border-slate-400/70 bg-slate-700/80 text-slate-50",
  EN_COURS: "border-emerald-300/80 bg-emerald-700/90 text-emerald-50",
  SUSPENDUE: "border-amber-300/80 bg-amber-700/90 text-amber-50",
  TERMINEE: "border-blue-300/80 bg-blue-700/90 text-blue-50",
  PLANIFIE: "border-slate-400/70 bg-slate-700/80 text-slate-50",
  REALISE: "border-emerald-300/80 bg-emerald-700/90 text-emerald-50",
  ECHEC: "border-red-300/80 bg-red-700/90 text-red-50",
};

export default function ExecutionStatusBadge({ value }: { value: string }) {
  return (
    <span
      className={`inline-flex rounded-full border px-2.5 py-1 text-xs font-bold tracking-wide ${STATUS_CLASS[value] ?? STATUS_CLASS.PLANIFIEE}`}
    >
      {value}
    </span>
  );
}
